const path = window['themeSettings']['theme_uri'];

window.assets = {
	splide: {
		js: `${path}/assets/dist/vendor/splide/splide.min.js`,
		css: `${path}/assets/dist/vendor/splide/splide.min.css`,
	},
	AOS: {
		js: `${path}/assets/dist/vendor/aos.js`,
	},
	rellax: {
		js: `${path}/assets/dist/vendor/rellax.min.js`,
	},
	tilt: {
		js: `${path}/assets/dist/vendor/tilt.jquery.js`,
	},
};